import React, { useState } from "react";
import DepartMentList from "./Department/mainDepartment";
import TargetList from "./Targetssalary/mainTargets";
import { ROLE } from "../../../../../utils/Constant";
import EmpList from "./Employee/mainEmp";
import AllAttendence from "./Employee/allempattendence";

const button = {
    padding: "16px 20px",
    background: "transparent",
    color: "rgb(100, 116, 139)",
    borderWidth: " medium medium 3px",
    borderStyle: "none none solid",
    borderColor: " currentcolor currentcolor transparent",
    borderImage: "initial",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "0.2s",
}
const Activebutton = {
    padding: "16px 20px",
    background: "transparent",
    color: "rgb(1, 92, 87)",
    borderWidth: " medium medium 3px",
    borderStyle: "none none solid",
    borderColor: "currentcolor currentcolor rgb(1, 92, 87)",
    borderImage: "initial",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "0.2s",
}
const MainEmp = ({ admin }) => {
    const [viewType, setviewType] = useState('emp')
    const [editData, seteditData] = useState('')

    const editHandler = (data) => {
        console.log(data)
        if (data.id) {
            seteditData(data)
            setviewType('add')
        }



    }
    const ChangeScreen = (type) => {
        seteditData('')
        setviewType(type)
    }
    return (
        <div className="container-fluid">

            {/* <div className="row fixed-top" style={{ marginTop: '76px', display: 'flex', width: '100%', zIndex: '10' }}>

                <div className={`expenseListTab ${viewType == "emp" ? "active" : ""}`} onClick={() => setviewType('emp')} style={{ textAlign: 'center', background: '#DBE9FF', width: '25%', borderRadius: '0' }}>
                    Employees

                </div>
                {
                    admin.rolelist.indexOf(ROLE.VIEW_EMPLOYEE_ATTENDENCE) >= 0 && (
                        <div className={`expenseListTab ${viewType == "attendence" ? "active" : ""}`} onClick={() => setviewType('attendence')} style={{ textAlign: 'center', background: '#DBE9FF', width: '25%', borderRadius: '0' }}>
                            All Employee Attendance

                        </div>
                    )}
                <div className={`expenseListTab ${viewType == "department" ? "active" : ""}`} onClick={() => setviewType('department')} style={{ textAlign: 'center', background: '#DBE9FF', width: '25%', borderRadius: '0' }}>
                    Departments

                </div>
                <div className={`expenseListTab ${viewType == "target" ? "active" : ""}`} onClick={() => setviewType('target')} style={{ textAlign: 'center', background: '#DBE9FF', width: '25%', borderRadius: '0' }}>
                    Targets

                </div>

            </div> */}

            <div className="row fixed-top" style={{ marginTop: '74.5px', display: 'flex', width: '100%', zIndex: '10', background: "rgb(248, 250, 252)", borderBottom: "1px solid rgb(226, 232, 240)",justifyContent:'end' }}>
                <button style={viewType == "emp" ? Activebutton : button} onClick={() => setviewType('emp')}>Employees</button>
                {
                    admin.rolelist.indexOf(ROLE.VIEW_EMPLOYEE_ATTENDENCE) >= 0 && (
                        <button style={viewType == "attendence" ? Activebutton : button} onClick={() => setviewType('attendence')}>All Employee Attendance</button>
                    )}
                <button style={viewType == "department" ? Activebutton : button} onClick={() => setviewType('department')}> Departments</button>
                <button style={viewType == "target" ? Activebutton : button} onClick={() => setviewType('target')}>Targets</button>
            </div>
            <div style={{ marginTop: '80px' }}>
                {viewType === 'emp' ?
                    <EmpList showButton={false} admin={admin} editHandler={editHandler} />
                    : ""}
                {viewType === 'department' ?
                    <DepartMentList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'target' ?
                    <TargetList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'attendence' ?
                    <AllAttendence showButton={false} admin={admin} editData={editData} />
                    : ""}
            </div>

        </div>
    )
}
export default MainEmp